import PropTypes from 'prop-types';

import { CardVideo } from '@/design-system/atoms/Cards/CardVideo';
import { ContentContainer } from '@/design-system/atoms/ContentContainer';
import { Grid, GridColumn } from '@/design-system/atoms/Grid';

import styles from './VideoCard.module.scss';

/**
 * Video card component that displays a CardVideo component in a grid.
 */
const VideoCard = (props) => {
    return (
        <ContentContainer
            className={
                props.contentWidth === 'fullWidth' && props.inGrid && styles[`remove-padding`]
            }
        >
            <Grid>
                <GridColumn
                    colSpan={{
                        sm: 4,
                        md: 6,
                        lg: props.contentWidth === 'fullWidth' ? 12 : 6,
                    }}
                >
                    <CardVideo className={styles['video-card']} {...props} />
                </GridColumn>
            </Grid>
        </ContentContainer>
    );
};

VideoCard.propTypes = {
    /**
     * Width of video card.
     */
    contentWidth: PropTypes.oneOf(['fullWidth', 'inset']),
};

export default VideoCard;
